import React from 'react';
import { ValuesBackground, ValuesContainer, Title } from './styled';
import ValueCardsDesktop from './components/ValueCardsDesktop';
import ValueCards from './components/ValueCards';
import { VALUES } from './consts';

const Values = () => {
  return (
    <ValuesBackground>
      <ValuesContainer>
        <Title>Our values</Title>
        <ValueCardsDesktop values={VALUES} />
        <ValueCards values={VALUES} />
      </ValuesContainer>
    </ValuesBackground>
  );
};

export default Values;
